import { Desktop } from '../../components/media'
import AvatarSvg from '../svg/avatar'
import CloseX from '../svg/close-x'
import Avatar from '../avatar'
import DealerAvatar from '../svg/avatar-dealer'
import { useMemo } from 'react'

export default function Header({ data, onClose, errorMessage }) {
  const { topic, profilePictureUrl, displayName, isDealer, isAdmin, isConcierge } = data

  const role = useMemo(() => {
    if (isAdmin) return '(Administrator)'
    if (isConcierge) return '(Concierge)'

    return ''
  }, [isAdmin, isConcierge])

  return (
    <div className='wrapper flex alignCenter justifyBetween'>
      <div className='flex alignCenter'>
        <div className='userAvatar'>
          <Avatar
            alt='user avatar'
            width={50}
            height={50}
            src={profilePictureUrl}
            fallbackComponent={isDealer ? DealerAvatar : AvatarSvg}
          />
        </div>

        <div className='userInfo flex flexDirectionColumn'>
          <span>
            {displayName} {role && <span className='adminLabel'>{role}</span>}
          </span>
          <span>{topic}</span>
        </div>
      </div>

      {errorMessage && <p className='error'> {errorMessage} </p>}

      <Desktop>
        <button className='flatBtn' onClick={onClose} aria-label='close'>
          <CloseX width='22' height='22' fill='var(--secondary-button-bg' />
        </button>
      </Desktop>

      <style jsx>{`
        .wrapper {
          width: 100%;
          height: 5rem;
        }

        .userAvatar {
          :global(img),
          :global(svg) {
            width: 5rem;
            height: 5rem;
            border-radius: 50%;
            object-fit: cover;
          }
        }

        .userInfo {
          margin: 0 0 0 1.2rem;

          span {
            color: var(--secondary-text-color);
            line-height: 1.9rem;
            font-size: 1.4rem;

            &:first-of-type {
              color: var(--primary-text-color);
              line-height: 2.4rem;
              font-size: 1.8rem;
              font-weight: 700;
            }

            .adminLabel {
              color: var(--alert-color);
              font-size: 1.4rem;
            }
          }
        }

        .error {
          color: var(--alert-color);
          font-size: 1.6rem;
        }

        @media (max-width: 1024px) {
          .userAvatar {
            :global(img),
            :global(svg) {
              width: 3.5rem;
              height: 3.5rem;
            }
          }

          .userInfo {
            margin: 0 0 0 0.8rem;

            span {
              line-height: 1.4rem;
              font-size: 1rem;

              &:first-of-type {
                line-height: 1.6rem;
                font-size: 1.2rem;
              }
            }
          }

          .error {
            margin: 0 0 0 1rem;
          }
        }
      `}</style>
    </div>
  )
}
